import { render } from "./TransIntro.vue?vue&type=template&id=ff9ecc4e&scoped=true&ts=true"
import script from "./TransIntro.vue?vue&type=script&lang=ts"
export * from "./TransIntro.vue?vue&type=script&lang=ts"

import "./TransIntro.vue?vue&type=style&index=0&id=ff9ecc4e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff9ecc4e"]])

export default __exports__